import { find } from 'lodash-es'

/**
 * Resolves what kind of element a guid refers to, checked once at selection time so the selection
 * carries its `elementType` and consumers (drawer resolution, mode adoption) don't have to rescan
 * the model. Positions (rips/lintels) match by `position_guid`, openings by scanning the walls.
 */
const resolveSelectedElementType = (
  model: PlanarModel,
  elementGuid: string,
): PlanarSelectedElementType | undefined => {
  const opening = model.walls.some(wall =>
    wall.openings?.some((o: Opening) => o.guid === elementGuid),
  )
  if (opening) return 'opening'

  const lintel = find(model.lintels, { position_guid: elementGuid })
  if (lintel) return 'lintel'

  const rip = find(model.rips, { position_guid: elementGuid })
  if (rip) return 'rip'

  const modelElement = find(
    [
      ...model.walls,
      ...model.slabs,
      ...model.roof_slabs,
      ...model.vertical_slabs,
      ...model.beams,
      ...model.purlins,
      ...model.columns,
      ...model.vertical_roof_slabs,
      ...model.foundationElements,
    ],
    ['guid', elementGuid],
  )

  return modelElement?.element_type
}

export default resolveSelectedElementType
